import { CATEGORY_META, type Assignee, type Category } from '@travel-planner/shared';

export function CategoryBadge({ category }: { category: Category }) {
  const meta = CATEGORY_META[category];
  return (
    <span
      className="badge rounded-pill d-inline-flex align-items-center gap-1"
      style={{ background: meta.color, color: '#fff', fontSize: '0.7rem', whiteSpace: 'nowrap' }}
    >
      <span aria-hidden>{meta.icon}</span>
      {meta.label}
    </span>
  );
}

const ASSIGNEE_LABEL: Record<Assignee, string> = { joel: 'Joel', lea: 'Lea', both: 'Both' };

export const assigneeLabel = (a: Assignee): string => ASSIGNEE_LABEL[a];

export function AssigneeChip({ assignee }: { assignee: Assignee }) {
  return (
    <span
      className="badge rounded-pill"
      style={{
        background: 'var(--surface-2)',
        color: 'var(--text-muted)',
        fontSize: '0.7rem',
        whiteSpace: 'nowrap',
      }}
    >
      {ASSIGNEE_LABEL[assignee]}
    </span>
  );
}
